import { environment } from '@lla-platform/core/core-util'

export const Tracker_API_URL = {
  base: `${environment.apiUrl}/tracker`,
  exportTrackersData: `${environment.apiUrl}/tracker/export`
}
